import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';

import { LoadingSpinnerProps } from './LoadingSpinnerTypes';
import StyledLoadingSpinner from './StyledLoadingSpinner';

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ loading }) => {
  const spinTransition = {
    loop: Infinity,
    ease: 'linear',
    duration: 1,
  };

  return (
    <StyledLoadingSpinner>
      <AnimatePresence>
        {loading && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <motion.span className="circle" animate={{ rotate: 360 }} transition={spinTransition} />
          </motion.div>
        )}
      </AnimatePresence>
    </StyledLoadingSpinner>
  );
};

export default LoadingSpinner;
